import React from 'react';
import { Routes, Route } from 'react-router-dom';
import RentalForm from './components/RentalForm/RentalForm';
import RentalList from './components/RentalList/RentalList';
import RentalDetails from './components/RentalDetails/RentalDetails';
import ProtectedRoute from "./ProtectedRoute";
import LoginPage from "./components/LoginPage";
import FullReport from "./components/reports/FullReport";

import 'bootstrap/dist/css/bootstrap.min.css';


function App() {

    return (
            <div className="container py-4">
                <Routes>
                    <Route path="/login" element={<LoginPage />} />
                    <Route path="/unauthorized" element={<div>Доступ запрещен</div>} />

                    <Route path="/" element={
                        <ProtectedRoute allowedRoles={['admin', 'courier']}>
                            <RentalList />
                        </ProtectedRoute>
                    } />
                    <Route path="/rental" element={
                        <ProtectedRoute allowedRoles={['admin', 'courier']}>
                            <RentalList />
                        </ProtectedRoute>
                    } />
                    <Route path="/new" element={
                        <ProtectedRoute allowedRoles={['admin']}>
                            <RentalForm />
                        </ProtectedRoute>
                    } />
                    <Route path="/rental/:id" element={
                        <ProtectedRoute allowedRoles={['admin', 'courier']}>
                            <RentalDetails />
                        </ProtectedRoute>
                    } />
                    <Route path="/reports" element={
                        <ProtectedRoute allowedRoles={['admin']}>
                            <FullReport />
                        </ProtectedRoute>
                    } />
                </Routes>
            </div>
    );
}

export default App;
